var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "download_FILL0_wght200_GRAD200_opsz24 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.9564 26.2115L12.3923 18.6474L14.3634 16.7404L18.5814 20.9583V7H21.3314V20.9583L25.5493 16.7404L27.5205 18.6474L19.9564 26.2115ZM10.7737 33C9.70867 33 8.81314 32.637 8.08709 31.911C7.36106 31.1849 6.99805 30.2894 6.99805 29.2244V25.1859H9.74805V29.2244C9.74805 29.4808 9.85488 29.7158 10.0685 29.9295C10.2822 30.1432 10.5173 30.25 10.7737 30.25H29.2224C29.4788 30.25 29.7139 30.1432 29.9275 29.9295C30.1412 29.7158 30.248 29.4808 30.248 29.2244V25.1859H32.998V29.2244C32.998 30.297 32.635 31.1944 31.909 31.9167C31.1829 32.6389 30.2874 33 29.2224 33H10.7737Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload2);
export default __webpack_public_path__ + "static/media/download2.e43f3e6030699b5ee936efcd5630da65.svg";
export { ForwardRef as ReactComponent };